import Profile from "./Profile.png"


const Images = {Profile}

export default  Images;